export const styles = {
  link: {
    textDecoration: 'none',
  },
};
